import WeatherWidgetDetails from 'features/Weather/components/WeatherWidgetDetails/WeatherWidgetDetails';
import { useId } from 'react';
import WeatherMapList, {
  WeatherMapListButton,
} from '../../../../components/WeatherMapList/WeatherMapList';
import { hurricaneDetailGroups, hurricaneDetails } from '../../config/hurricaneDetails.config';
import {
  formatStormWindSpeed,
  getLatestStormRecord,
  getStormDisplayLabel,
} from '../../utils/hurricanes.utils';

// Details for the selected storm, or a storm list when every live storm is
// shown at once. `activeRecord` follows the replay scrubber so the numbers
// match the point currently highlighted on the map.
const StormDetailsPanel = ({ storm, stormGroups = [], activeRecord, onSelectStorm }) => {
  const headingId = useId();
  const record = activeRecord ?? getLatestStormRecord(storm?.records ?? []);

  if (storm && record) {
    const stormLabel = getStormDisplayLabel(storm);

    return (
      <section
        aria-labelledby={headingId}
        className="hurricanes-storm-details d-flex min-w-0 flex-shrink-0 flex-column gap-2"
      >
        <header>
          <div className="small text-uppercase text-secondary fw-semibold">Selected storm</div>
          <h2 id={headingId} className="m-0 fs-6 fw-bold text-break">
            {stormLabel}
          </h2>
        </header>

        <WeatherWidgetDetails
          selectedItem={record}
          details={hurricaneDetails}
          layoutGroups={hurricaneDetailGroups}
          containerClassName="weather-map-detail-grid hurricanes-detail-grid"
          iconSize={16}
          ariaLabel={`Details for ${stormLabel}`}
        />
      </section>
    );
  }

  return (
    <WeatherMapList
      title="Active Storms"
      countLabel={`${stormGroups.length} ${stormGroups.length === 1 ? 'storm' : 'storms'}`}
      className="hurricanes-storm-list"
      listClassName="hurricanes-storm-list-items"
    >
      {stormGroups.map((stormGroup) => {
        const latestRecord = getLatestStormRecord(stormGroup.records);

        return (
          <li key={stormGroup.key}>
            <WeatherMapListButton
              className="hurricanes-storm-list-button align-items-center justify-content-between gap-3 p-3"
              onClick={() => onSelectStorm?.(stormGroup.key)}
            >
              <span className="d-flex min-w-0 flex-column gap-1">
                <span className="fw-semibold text-break">{getStormDisplayLabel(stormGroup)}</span>
                <span className="small text-secondary">Select to view its track and details</span>
              </span>
              <span className="small text-secondary text-nowrap fw-semibold">
                {formatStormWindSpeed(latestRecord?.wind_speed)}
              </span>
            </WeatherMapListButton>
          </li>
        );
      })}
    </WeatherMapList>
  );
};

export default StormDetailsPanel;
